"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_to_input_1 = require("../helpers/date-to-input");
var Session = require("./session");
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var user = null;
var promise = null;
var updateUser = function (userData) {
    if (!userData["birthday"]) {
        return userData;
    }
    return Object.assign({}, userData, {
        birthday: date_to_input_1.DateToInput(userData["birthday"] * 1000)
    });
};
var current = function (options) {
    if (options === void 0) { options = {}; }
    if (options["forceFetch"]) {
        user = promise = null;
    }
    if (user) {
        return Promise.resolve(user);
    }
    if (promise) {
        return promise;
    }
    promise = Request.sendGet(constants_1.endpoints.api + "/user")
        .then(updateUser);
    return promise;
};
exports.current = current;
var save = function (data) {
    if (data["birthday"] && parseInt(data["birthday"], 10) !== data["birthday"]) {
        data["birthday"] = +new Date(data["birthday"]) / 1000;
    }
    return Request.sendPut(constants_1.endpoints.api + "/user", data)
        .then(updateUser);
};
exports.save = save;
var updateWith = function (data) {
    if (!user) {
        return;
    }
    updateUser(Object.assign({}, user, data));
};
exports.updateWith = updateWith;
Session.onSignedOut(function () {
    user = promise = null;
});
//# sourceMappingURL=user.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/user.js
// module id = 877
// module chunks = 3